export default __webpack_public_path__ + "static/media/16.f93d8a90.svg";